import { EyeshadowType } from "./v1";

export type EyeshaowTypeV1Type = keyof typeof EyeshadowType;
export type EyeshaowTypeType = EyeshaowTypeV1Type;
